import styled from "styled-components";
import { FaExchangeAlt, FaChartLine, FaColumns } from "react-icons/fa";
import Text from "../../../utils/Text";
import { useState } from "react";
import { HOME } from "../../../constants/urls";
import { GiCardExchange } from "react-icons/gi"
import { useMainContext } from "../../../contexts/main"


const BottomBar = () => {

    const { main: { lang } } = useMainContext()
    const [active, setActive] = useState(3)


    const onTabClicked = (tab, idx) => {
        if (tab.external) {
            return
        } else {
            window.location.href = HOME + lang + `/${tab.href}`
        }
        setActive(idx)
    }

    return (
        <Body>
            <BottomBarWrapper>
                {tabs.map((tab, idx) => (
                    <TabItem onClick={() => onTabClicked(tab, idx)}>
                        <tab.icon size={18} active={idx === active} />
                        <DText color={active === idx ? 'rgb(39, 163, 220)' : ''}>
                            <Text tid={tab.name} />
                        </DText>
                    </TabItem>
                ))}
            </BottomBarWrapper>
        </Body>
    )
}


const DashboardIcon = styled(FaColumns)`
	color: ${(props) => (props.active ? 'rgb(39, 163, 220)' : props.theme.color)};
`
const MarketsIcon = styled(FaChartLine)`
	color: ${(props) => (props.active ? 'rgb(39, 163, 220)' : props.theme.color)};
`
const OtcIcon = styled(FaExchangeAlt)`
	color: ${(props) => (props.active ? 'rgb(39, 163, 220)' : props.theme.color)};
`
const WalletIcon = styled(GiCardExchange)`
	color: ${(props) => (props.active ? 'rgb(39, 163, 220)' : props.theme.color)};
`

const tabs = [
    { name: 'home-page', icon: DashboardIcon, href: '/' },
    { name: 'otc-trade', icon: OtcIcon, href: '/btc' },
    { name: 'markets', icon: MarketsIcon, href: '/market' },
    { name: 'p2p-trade', icon: WalletIcon, href: '/trade', external: true },
]

const DText = styled.div`
	font-size: 0.8rem;
  color: ${props => props.color || props.theme.color}  ;
`

const Body = styled.div`
  position: fixed;
  bottom: 0;
  width: 100%;
  height: 60px;
  direction: ${props => props.theme.english ? "ltr" : "rtl"};
  background-color: ${props => props.theme.secondaryBg};
  box-shadow: -2px 0 4px ${props => props.theme.mainBg};
  padding: 10px 20px;
  z-index: 100;
`

const BottomBarWrapper = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	color: ${(props) => (props.active ? props.theme.mainOrange : props.theme.color)};
`


const TabItem = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	align-items: center;
	height: 40px;
`



export default BottomBar;
